// Shared with packages/app through the review-target schemas, so no runtime imports.

// What a collection may hold, as the agent and the review card name it. "any" is a
// collection with no base type, which takes every kind but products.
export const ASSET_COLLECTION_MEDIA_KINDS = [
  "image",
  "video",
  "component",
  "any",
] as const;
export type AssetCollectionMediaKind =
  (typeof ASSET_COLLECTION_MEDIA_KINDS)[number];

// Why a dropped file is left out of an upload batch.
export const LIBRARY_UPLOAD_LEFT_OUT_REASONS = [
  "exact_duplicate",
  "near_duplicate",
  "low_quality",
  "draft_or_rejected",
  "other",
] as const;
export type LibraryUploadLeftOutReason =
  (typeof LIBRARY_UPLOAD_LEFT_OUT_REASONS)[number];

export const LIBRARY_UPLOAD_PROGRESS_STATUSES = [
  "queued",
  "running",
  "done",
  "failed",
] as const;
export type LibraryUploadProgressStatus =
  (typeof LIBRARY_UPLOAD_PROGRESS_STATUSES)[number];
